export const aboutInfo = {
  brand: {
    title: "品牌介绍",
    content: [
      "必赢国际成立于2015年，总部位于新加坡，是一家以技术驱动的国际化综合服务平台。经过十余年的稳健发展，必赢国际已经从一家区域性服务商成长为业务遍及全球30多个国家和地区的行业领军企业。",
      "必赢国际始终坚持以技术创新为核心驱动力，汇聚了来自全球顶尖科技公司的技术人才，在分布式系统、人工智能、区块链等前沿技术领域持续投入研发资源。平台自主研发的智能服务系统，能够为不同国家和地区的用户提供个性化、本地化的优质服务体验。",
      "作为一家具有国际视野的企业，必赢国际积极践行企业社会责任，在环境保护、教育公益、社区发展等领域持续投入，用实际行动回馈社会。我们相信，一家优秀的企业不仅要创造商业价值，更要为社会进步贡献力量。",
    ],
  },
  reputation: {
    title: "信誉保障",
    certifications: [
      { name: "ISO 27001 信息安全管理认证", icon: "ri-shield-check-line", desc: "国际权威信息安全标准认证，确保用户数据安全" },
      { name: "PCI DSS 支付安全认证", icon: "ri-bank-card-line", desc: "全球支付卡行业数据安全标准，保障支付安全" },
      { name: "GLI 国际游戏实验室认证", icon: "ri-test-tube-line", desc: "国际独立测试实验室认证，确保公正性" },
      { name: "GDPR 数据保护合规", icon: "ri-lock-2-line", desc: "欧盟通用数据保护条例合规，保护用户隐私" },
    ],
    stats: [
      { value: "1000万+", label: "全球注册用户" },
      { value: "30+", label: "覆盖国家和地区" },
      { value: "99.9%", label: "服务可用率" },
      { value: "7×24", label: "全天候客服支持" },
    ],
  },
  contact: {
    title: "联系我们",
    email: "service@biyingguoji.com",
    phone: "+65 6789 0000",
    address: "新加坡滨海湾金融中心",
    workingHours: "周一至周日 全天24小时",
  },
};

export const faqs = [
  {
    question: "如何注册必赢国际账号？",
    answer: "访问必赢国际官方网站，点击右上角\"立即注册\"按钮，填写基本信息并完成手机或邮箱验证即可成功注册。整个过程仅需2-3分钟。",
  },
  {
    question: "必赢国际是否安全可靠？",
    answer: "必赢国际获得ISO 27001、PCI DSS等多项国际权威认证，采用银行级加密技术保护用户数据，并实行用户资金第三方托管，全面保障平台安全性。",
  },
  {
    question: "如何提升会员等级？",
    answer: "会员等级根据您在平台的累计活跃度自动评定。您可以通过日常使用、参与活动、邀请好友等方式积累活跃度，达到对应门槛后系统将自动为您升级。",
  },
  {
    question: "优惠活动如何参与？",
    answer: "登录您的必赢国际账号后，前往\"优惠活动\"页面即可查看当前所有进行中的活动。点击活动详情页了解参与条件和规则，按要求操作即可获得相应奖励。",
  },
  {
    question: "遇到问题如何联系客服？",
    answer: "必赢国际提供7×24小时多语言客服支持。您可以通过在线客服、官方邮箱service@biyingguoji.com或客服热线与我们取得联系，我们的客服团队将第一时间为您解决问题。",
  },
];